import type { ThinkingLevel } from "@memorix/agent-core";

export const DEFAULT_THINKING_LEVEL: ThinkingLevel = "medium";
